/* eslint-disable no-empty-pattern */
import http from '@plugins/axios';
import { queryString } from '@utils/format';

export const actions = {
  async fetch({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`psp/i/${id}/pelatihan/imbas-kelas?${queryString(payload.params)}`).then(({ data }) => data);
  },

  async kelas({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http.get(`psp/i/${id}/pelatihan/imbas-kelas/${payload.id}/fetch`).then(({ data }) => data);
  },

  async candidate({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http
      .get(`psp/i/${id}/pelatihan/imbas-kelas/${payload.endpoint}?${queryString(payload.params)}`)
      .then(({ data }) => data);
  },

  async action({ rootState }, payload) {
    const id = rootState.auth.instansi_id;
    return await http
      .post(
        `psp/i/${id}/pelatihan/imbas-kelas${payload.id ? `/${payload.id}` : ''}/${payload.endpoint}`,
        payload.params
      )
      .then(({ data }) => data);
  },
};
